import { useTranslation } from "react-i18next";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangleIcon, FileTextIcon, DollarSignIcon, CheckCircleIcon, RotateCcwIcon, ChevronRightIcon, ServerIcon, RefreshCcwIcon, LinkIcon, SettingsIcon } from 'lucide-react';
import { getTenant } from '../../../theme/tokens';
import { mockBills } from '../../bills/mocks/mockBills';
export function Notifications() {
  const {
    t
  } = useTranslation("notifications");
  const navigate = useNavigate();
  const pendingBills = mockBills.filter(b => b.status === 'pending_approval');
  const recentActivity = [{
    id: 1,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 45,000 from John Doe`,
    time: '10 mins ago',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 2,
    type: 'bill',
    title: 'Bill approved',
    desc: 'INV-2026-003 by Simon Verraest',
    time: '1 hour ago',
    icon: CheckCircleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 3,
    type: 'dispute',
    title: 'New dispute opened',
    desc: `${getTenant().currency.code} 1,538.94 - Fraudulent`,
    time: '3 hours ago',
    icon: AlertTriangleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 4,
    type: 'refund',
    title: 'Refund processed',
    desc: `${getTenant().currency.code} 2,500 to Sarah Smith`,
    time: '5 hours ago',
    icon: RotateCcwIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 5,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 12,400 from Acme Corp`,
    time: 'Yesterday',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }];
  return <div data-id="element-7057">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-7058">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-7059">{t("pages.Notifications.notifications")}</h1>
        <button onClick={() => navigate('/settings')} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-7060">
          
          <SettingsIcon size={14} data-id="element-7061" />
          {t("pages.Notifications.manage_preferences")}
        </button>
      </div>

      {/* Notification Center */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-7062">
        {/* Section: Urgent */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200" data-id="element-7063">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-7064">
            <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-7065"></span>
            {t("pages.Notifications.urgent_requires_immediate_action")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7066">
          <button onClick={() => navigate('/disputes/1')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7067">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7068">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-7069" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-7070">
              <p className="text-sm font-medium text-gray-900" data-id="element-7071">
                {t("pages.Notifications.dispute_dp20240001_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7072">
                {t("pages.Notifications.usd_10001_fraudulent_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-7073">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-7074">
                {t("pages.Notifications.due_in_2h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7075" />
            
          </button>
          <button onClick={() => navigate('/disputes/91')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7076">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7077">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-7078" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-7079">
              <p className="text-sm font-medium text-gray-900" data-id="element-7080">
                {t("pages.Notifications.dispute_dp20240091_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7081">
                {t("pages.Notifications.usd_153894_duplicate_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-7082">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-7083">
                {t("pages.Notifications.due_in_5h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7084" />
            
          </button>
        </div>

        {/* Section: Bills */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7085">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-7086">
            <span className="w-2 h-2 rounded-full bg-[#FF4500]" data-id="element-7087"></span>
            {t("pages.Notifications.bills_pending_approval")} {pendingBills.length} {t("pages.Notifications.items")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7088">
          {pendingBills.slice(0, 4).map(bill => <button key={bill.id} onClick={() => navigate(`/bill-detail/${bill.id}`)} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-7089">
            
              <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7090">
                <FileTextIcon size={16} className="text-gray-600" data-id="element-7091" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-7092">
                <p className="text-sm font-medium text-gray-900" data-id="element-7093">
                  {bill.supplierName}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-7094">
                  {bill.billNumber} {t("pages.Notifications.due")}{' '}
                  {new Date(bill.dueDate).toLocaleDateString('en-GB')}
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-7095">
                <p className="text-sm font-semibold text-gray-900" data-id="element-7096">
                  {bill.currency} {bill.amount.toLocaleString()}
                </p>
              </div>
              <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-7097" />
            
            </button>)}
          {pendingBills.length > 4 && <button onClick={() => navigate('/bills')} className="w-full px-5 py-3 text-sm font-medium text-[#FF4500] hover:bg-gray-50 transition-colors text-center" data-id="element-7098">
            
              {t("pages.Notifications.view_all")} {pendingBills.length} {t("pages.Notifications.pending_bills")}
            </button>}
        </div>

        {/* Section: Recent Activity */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7099">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-7100">
            {t("pages.Notifications.recent_activity")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7101">
          {recentActivity.map(activity => <div key={activity.id} className="flex items-center gap-4 px-5 py-4" data-id="element-7102">
            
              <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${activity.color}`} data-id="element-7103">
              
                <activity.icon size={16} data-id="element-7104" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-7105">
                <p className="text-sm font-medium text-gray-900" data-id="element-7106">
                  {activity.title}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-7107">{activity.desc}</p>
              </div>
              <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-7108">
                {activity.time}
              </span>
            </div>)}
        </div>

        {/* Section: System */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-7109">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-7110">
            {t("pages.Notifications.system_status")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-7111">
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7112">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7113">
              <ServerIcon size={16} className="text-gray-600" data-id="element-7114" />
            </div>
            <div className="flex-1" data-id="element-7115">
              <p className="text-sm font-medium text-gray-900" data-id="element-7116">{t("pages.Notifications.api_uptime")}</p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7117">
                {t("pages.Notifications.all_systems_operational")}
              </p>
            </div>
            <span className="text-sm font-bold text-green-600" data-id="element-7118">99.99%</span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7119">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7120">
              <RefreshCcwIcon size={16} className="text-gray-600" data-id="element-7121" />
            </div>
            <div className="flex-1" data-id="element-7122">
              <p className="text-sm font-medium text-gray-900" data-id="element-7123">
                {t("pages.Notifications.last_settlement")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7124">
                {t("pages.Notifications.completed_successfully")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-7125">
              {t("pages.Notifications.0130_am")}
            </span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-7126">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-7127">
              <LinkIcon size={16} className="text-gray-600" data-id="element-7128" />
            </div>
            <div className="flex-1" data-id="element-7129">
              <p className="text-sm font-medium text-gray-900" data-id="element-7130">
                {t("pages.Notifications.active_payment_links")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-7131">
                {t("pages.Notifications.currently_receiving_traffic")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-7132">142</span>
          </div>
        </div>
      </div>
    </div>;
}